// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3R_yy","main":"Layout_main__22dVF","hideFooter":"Layout_hideFooter__2VTvC"};